"use client";

import { useSession } from "next-auth/react";

import type { Plan } from "@/types";
import { isUserPremium } from "@/lib/utils";
import type { SubscriptionFrequency } from "@/app/subscription/[frequency]/types";

import { TabsContent } from "@/components/ui/tabs";
import PlanCard from "@/components/cards/PlanCard";
import PlanButton from "@/components/cards/PlanCard/PlanButton";

type Props = {
	plans: Plan[];
	frequency: SubscriptionFrequency;
	offer?: string;
};

export default function PlanTabItem({ frequency, plans, offer }: Props) {
	const { data: session, update } = useSession();

	const isPremiumUser = isUserPremium(session?.user.plan.duration);
	const xyz = isPremiumUser ? plans.filter((x) => x.prices[0].amount !== 0) : plans;

	return (
		<TabsContent value={frequency} className="muted-scrollbar grid max-w-full">
			<h1 className="flex h-12 items-center justify-center text-sm text-secondary lg:text-base">
				{offer}
			</h1>
			<div className="grid snap-x snap-mandatory scroll-pl-8 grid-flow-col gap-8 overflow-x-auto pb-8 before:w-8 after:w-8 sm:scroll-pl-0 sm:before:hidden sm:after:hidden">
				{xyz.map((plan) => (
					<PlanCard
						key={plan._id ?? plan.name}
						frequency={frequency}
						plan={plan}
						renderPlanButton={
							<PlanButton
								plan={plan}
								frequency={frequency}
								session={session}
								updateSession={update}
							/>
						}
					/>
				))}
			</div>
		</TabsContent>
	);
}
